import googleMapsApiLoader from 'google-maps-api-loader';

let searchFormEl;

function init() {

	searchFormEl = document.querySelector('.dash-search form');

	if (!searchFormEl) {
		return;
	}

	googleMapsApiLoader({
		libraries: ['places'],
		apiKey: 'AIzaSyAgYWo4_VL_oAbM0ARvq6rStRUN1deK7R0'
	}).then((api) => {
		initSearch(api);
		return api;
	});

}

function initSearch(googleApi) {

	const searchInputEl = searchFormEl.querySelector('input[type="text"]');
	const autocomplete = new googleApi.maps.places.Autocomplete(searchInputEl, {
		types: ['(cities)'],
		componentRestrictions: {
			country: 'fi'
		}
	});

	let autocompletePlace;

	searchFormEl.addEventListener('submit', (event) => {

		event.preventDefault();

		if (!searchInputEl.value.trim()) {
			searchInputEl.focus();
		} else if (autocompletePlace && autocompletePlace.geometry) {
			window.location = `${searchFormEl.action}?place_id=${autocompletePlace.place_id}`;
		} else {
			searchInputEl.focus();
		}
	});

	searchInputEl.addEventListener('change', () => {
		autocompletePlace = null;
	});

	autocomplete.addListener('place_changed', () => {
		autocompletePlace = autocomplete.getPlace();
	});

}

export default {
	init
};
